import React from "react";
import { Route, Redirect } from "react-router-dom";

export default ({ component: Component, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login"
          }}
        />
      )
    }
  />
);



// WEBPACK FOOTER //
// ./src/services/PrivateRoute.js